import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  onClick?: () => void;
  className?: string;
  scrollTo?: string;
  href?: string;
}
export function CTAButton({
  text = '¡QUIERO MI MENÚ KETO COLOMBIANO AHORA!',
  onClick,
  className = '',
  scrollTo = 'pricing',
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
      return;
    }
    if (onClick) {
      onClick();
      return;
    }
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`
        group relative inline-flex items-center justify-center 
        w-full sm:w-auto px-8 py-5 
        bg-[#F5C518] hover:bg-[#e0b416] 
        text-[#1A1A1A] font-montserrat font-black text-lg md:text-xl uppercase tracking-wide
        rounded-xl shadow-[0_8px_30px_rgba(245,197,24,0.3)]
        transition-all duration-300 ease-out
        hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(245,197,24,0.4)]
        active:translate-y-0 active:shadow-[0_4px_20px_rgba(245,197,24,0.3)]
        ${className}
      `} data-id="element-21">
      <span className="mr-2" data-id="element-22">{text}</span>
      <ChevronRightIcon className="w-6 h-6 transition-transform group-hover:translate-x-1" data-id="element-23" />
    </button>;
}